import { render, staticRenderFns } from "./MetadataDropdown.vue?vue&type=template&id=87881d48"
import script from "./MetadataDropdown.js?vue&type=script&lang=js&external"
export * from "./MetadataDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports